import React from 'react'
import QuestionIcon from '../images/question.svg'

interface IQuestions {
  header: string,
  description: string | React.ReactNode
}
export const QuestionsBlock = (questions: IQuestions[]) => {
  const [question, setQuestion] = React.useState<number>(-1)
  const getQuestion = (id: number) => (
    setQuestion(id)
  )
  return (
    <div className='onlinepbx__question'>
      {questions?.map((qst, index) => {
        return (
          <div
            key={index}
            className='onlinepbx__question__block'>
            <button
              className='onlinepbx__question__button'
              onClick={() => {
                if (question === index) {
                  getQuestion(-1)
                  return
                }
                getQuestion(index)
              }}>
              <QuestionIcon className='onlinepbx__question__icon' />
              {qst.header}
            </button>
            {question === index && questions[question].description || ''}
          </div>
        )
      })}
    </div>
  )
}

export default QuestionsBlock
